import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './Api/axiosConfig'; // global axios → Redux loader bridge
import './Core/utils/dateTime'; // global dayjs UTC + Toronto timezone setup
import App from './App';

const rootEl = document.getElementById("root") as HTMLElement;
const root = ReactDOM.createRoot(rootEl);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
